<template>
    <div>
        <div class="card dashcard mb-0">

            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-location-dot fa-fw"
                            placeholder="Consultar Amostra"
                            type="select"
                            optionsMode="aql"
                            service="amostra_rastro_status.index"
                            optionsData="id_amostra_rastro_status"
                            :optionsParm="{ rastreabilidade: true }"
                            :edicao="!paciente"
                            v-model="id_amostra_rastro_status"
                            @input="tratar_status" />
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            id="codigo"
                            name="codigo"
                            placeholder="Código..."
                            :edicao="( !paciente && ( !is_monta_bag || ( tipo_malote && malote && malote.status_rastro && malote.status_rastro.tipo == 'M' ) ) ) ? true : false"
                            v-model="codigo"
                            @onEnter="ler()">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary" @click.prevent="leitura_barcode = !leitura_barcode">
                                        <i class="fa-solid fa-barcode fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>

                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="exibicao">
                                    <span class="input-group-text" id="basic-addon2">{{ exibicao.length }}</span>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input 
                            id="pesq_pac"
                            name="pesq_pac"
                            placeholder="Consultar amostra do paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            :edicao="!id_amostra_rastro_status && !codigo"
                            v-model="paciente" 
                            :optimized_ac="true"
                            @selecionado="ler(true)">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">

                                    <button type="button" class="btn btn-outline-danger" @click="limpar_lista()" title="Limpar lista">
                                        <i class="fa-solid fa-eraser"></i>
                                    </button>

                                    <print-export printid="lista-amostras" :left="true" /> <!-- :dados="dadosFormatados" -->

                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2" v-if="is_monta_bag && info.bags && info.bags.lista">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            id="tipo_malote"
                            name="tipo_malote"
                            ref="info_malote"
                            placeholder="Tipo de Malote..."
                            type="select"
                            :optionsList="info.bags.lista"
                            optionsDisplay="nome"
                            v-model="tipo_malote"
                            @input="malote = null">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon2">
                                        <i class="fa-solid fa-box-open fa-fw"></i>
                                    </span>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>

        </div>
        <!-- Fim Header -->

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && exibicao"></div>
            <div class="determinate" v-else></div>
        </div>

         <!-- Leitura de Código de Barras -->

        <div v-if="leitura_barcode">

            <div id="qr-code-full-region"></div>

            <qrcode-scanner
                :qrbox="250" 
                :fps="10" 
                style="width: 300px;"
                @result="onScan"
            />

            <video id="beepElementId" src="/store-scanner-beep-90395.mp3" playsinline preload="auto" style="height: 10px;"></video> 

        </div>

        <div v-if="tipo_malote && tipo_malote && uo" class="mb-3">

            <div class="h5 d-flex justify-content-between">
                <div>{{ uo.st_nome }}</div>
                <div>
                    <span class="badge" :class="'badge-' + tipo_malote.cor" v-if="tipo_malote && tipo_malote.cor && tipo_malote.icone">
                        <i class="fa-fw" :class="tipo_malote.icone"></i>
                    </span>
                </div>
            </div>

            <hr>

            <template v-if="malote">

                <div class="row" v-if="info && info.bags && info.bags.amostras">
                    <div class="col col-12 col-md-6">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>Amostras do Malote</div>
                            <div>
                                {{ malote.codigo }}
                                <span class="badge badge-secondary ml-2">
                                    {{ malote.rastros.length }}
                                </span>

                                <a href="#" @click.prevent="imprimir_etiqueta_malote_2(malote.codigo, malote)" class="card-link ml-3" v-if="malote.rastros.length" title="Imprimir Etiqueta do Malote">
                                    <i class="fa-solid fa-barcode"></i>
                                </a>

                                <a href="#" @click.prevent="malote = null" class="card-link ml-3">
                                    <i class="fa-solid fa-angle-left"></i>
                                </a>
                            </div>
                        </div>

                        <ul class="list-group">
                            <li class="list-group-item" v-for="(amostra, imx) in malote.rastros" :key="imx">
                                <div v-if="amostra.leitura">
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <a href="#" class="card-link" @click.prevent="editar(amostra)">
                                                {{ amostra.st_codigo }}
                                            </a>
                                            <span v-if="amostra.st_titulo">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                {{ amostra.st_titulo }}
                                            </span>
                                            <span v-if="amostra.material">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                {{ amostra.material.st_amostra_material }}
                                            </span>
                                            <span v-if="amostra.st_destino">
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                {{ amostra.st_destino }}
                                            </span>
                                        </div>
                                        <div>
                                            <div class="mb-2 text-right">
                                                <a href="#" @click.prevent="remover_do_malote(amostra.st_codigo, malote.rastros, imx)" class="text-danger" title="Remover do Malote"
                                                    v-if="( tipo_malote && malote && malote.status_rastro && malote.status_rastro.tipo == 'M' )">
                                                    <i class="fa-solid fa-xmark"></i>
                                                </a>
                                            </div>
                                            <div v-if="false">
                                                <a href="#" @click.prevent="abrir_atendimento(amostra.exame.atendimento_procedimento.id_atendimento)" class="card-link">
                                                    #{{ amostra.exame.atendimento_procedimento.id_atendimento }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div>{{ amostra.exame.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                                </div>
                                <div v-else class="d-flex justify-content-between">
                                    <div>
                                        {{ amostra.amostra.codigo }}
                                        <span class="badge badge-dark ml-1" v-if="amostra.amostra.unidade_apoio && amostra.amostra.unidade_apoio.apoio">
                                            {{ amostra.amostra.unidade_apoio.apoio.sigla }}
                                        </span>
                                        <span class="badge ml-1" :class="'badge-' + amostra.amostra.status_rastro.cor" v-if="amostra.amostra.status_rastro">
                                            {{ amostra.amostra.status_rastro.nome }}
                                        </span>
                                        <div class="small text-muted">{{ amostra.amostra.material }}</div>
                                    </div>
                                    <div>
                                        <span class="text-muted" v-if="amostra.amostra.atendimento">#{{ amostra.amostra.atendimento.numero }}</span>    
                                        <a href="#" @click.prevent="remover_do_malote(amostra.amostra.codigo, malote.rastros, imx)" class="text-danger ml-3" title="Remover do Malote"
                                            v-if="( tipo_malote && malote && malote.status_rastro && malote.status_rastro.tipo == 'M' )">
                                            <i class="fa-solid fa-xmark"></i>
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col col-12 col-md-6" v-if="malote && malote.amostras"> 
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                Amostras Disponíveis
                            </div>
                            <div>
                                <span class="badge badge-secondary">
                                    {{ malote.amostras.length }}
                                </span>
                            </div>
                        </div>

                        <ul class="list-group">
                            <li class="list-group-item" v-for="(amostra_disp, idx) in malote.amostras" :key="idx">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        {{ amostra_disp.codigo }}
                                        <span class="badge badge-dark ml-1" v-if="amostra_disp.unidade_apoio && amostra_disp.unidade_apoio.apoio">
                                            {{ amostra_disp.unidade_apoio.apoio.sigla }}
                                        </span>
                                        <span class="badge ml-1" :class="'badge-' + amostra_disp.status_rastro.cor" v-if="amostra_disp.status_rastro">
                                            {{ amostra_disp.status_rastro.nome }}
                                        </span>
                                        <div class="small text-muted">{{ amostra_disp.material }}</div>    
                                        <div class="small text-muted" v-if="amostra_disp.atendimento && amostra_disp.atendimento.paciente">{{ amostra_disp.atendimento.paciente.nome }}</div>    
                                    </div>
                                    <div>
                                        <div class="small text-muted" v-if="amostra_disp.atendimento">#{{ amostra_disp.atendimento.numero }}</div>    
                                    </div>
                                </div>
                                <div> 
                                    <span class="badge badge-pill badge-primary mr-1" v-for="(epa, iex) in amostra_disp.exames" :key="iex">
                                        {{ epa.exame.exame.codigo_externo }}
                                        <i class="fa-solid fa-circle-exclamation text-danger" v-if="epa.exame.urgente" title="Urgente"></i>
                                    </span>
                                </div>
                            </li>
                        </ul>

                        <pre class="alert alert-secondary" v-if="false">{{ info.bags.amostras }}</pre>
                    </div>
                </div>

            </template>

            <template v-else>

                <div class="form-row">
                    <div class="col col-12 col-md-3" v-for="(bag, ibx) in tipo_malote.bags" :key="ibx">
                        <div class="card">
                            <div class="card-header d-flex justify-content-between h5 mb-0">
                                <div>{{ bag.codigo }}</div>
                            </div>
                            <div class="card-body">
                                <pre v-if="false">{{ bag }}</pre>

                                <div v-if="bag.status_rastro" class="mb-2">
                                    <span class="badge" :class="'badge-' + bag.status_rastro.cor">
                                        {{ bag.status_rastro.nome }}
                                    </span>
                                </div>

                                <div v-if="bag.rastros">
                                    {{ bag.rastros.length }} amostra(s)
                                </div>

                                <div v-else>
                                    Nenhuma amostra no malote
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="button" class="btn btn-sm btn-success mr-1" :disabled="$store.state.loading" @click="selecionar_malote(bag)">Selecionar</button>
                                <button type="button" class="btn btn-sm btn-outline-danger" :disabled="$store.state.loading" v-if="bag.rastros && !bag.rastros.length" @click="remover_malote(bag)">Remover</button>
                                <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="$store.state.loading" v-if="bag.status_rastro && bag.status_rastro.tipo == 'C'" @click="reabrir_malote(bag)">Reabrir</button>
                            </div>
                        </div>
                    </div>
                </div>

                <az-submit @click="criar_malote()" color="outline-success">
                    Criar Malote
                </az-submit>

            </template>

        </div>

        <template v-else>

            <div v-if="!exibicao || !exibicao.length">
                <az-empty-state icon="fa-solid fa-vial" msg="Nenhum amostra identificada." />
            </div>

            <div v-else id="lista-amostras">
                <ul class="list-group">
                    <li class="list-group-item" v-for="(amostra, iax) in exibicao" :key="iax">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <div>
                                    <a href="#" class="card-link" @click.prevent="editar(amostra)">
                                        {{ amostra.st_codigo }}
                                    </a>
                                    <span v-if="amostra.st_titulo">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ amostra.st_titulo }}
                                    </span>
                                    <span v-if="amostra.material">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ amostra.material.st_amostra_material }}
                                    </span>
                                    <span v-if="amostra.st_destino">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ amostra.st_destino }}
                                    </span>
                                </div>
                                <div>
                                    <a href="#" @click.prevent="abrir_atendimento(amostra.exame.atendimento_procedimento.id_atendimento)" class="card-link">
                                        #{{ amostra.exame.atendimento_procedimento.id_atendimento }}
                                    </a>
                                    <span class="small text-muted ml-3" v-if="amostra.exame.atendimento_procedimento.atendimento.marcacao.st_id_externo">
                                        {{ amostra.exame.atendimento_procedimento.atendimento.marcacao.st_id_externo }}
                                    </span>
                                    <span class="small text-muted ml-3">
                                        {{ $util.getFormatDate(amostra.exame.atendimento_procedimento.atendimento.dt_inicio) }} {{ amostra.exame.atendimento_procedimento.atendimento.dt_inicio.substr(11,5) }}
                                    </span>
                                </div>
                                <div>{{ amostra.exame.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                            </div>
                            <div class="col col-12 col-md-4 text-right">
                                <div v-if="amostra.rastro">
                                    <span class="badge" :class="'badge-' + ( amostra.rastro.status_rastro.st_color ? amostra.rastro.status_rastro.st_color : 'secondary' )">
                                        {{ amostra.rastro.status_rastro.st_amostra_rastro_status }}
                                    </span>
                                    <span v-if="amostra.rastro.st_bag_codigo">
                                        <span class="badge ml-2" :class="'badge-' + ( amostra.rastro.status_rastro.st_color ? amostra.rastro.status_rastro.st_color : 'secondary' )">
                                            <i class="fa-solid fa-box-open fa-fw mr-2" v-if="amostra.rastro.status_rastro.st_id_externo == 'M'"></i>
                                            <i class="fa-solid fa-box-archive fa-fw mr-2" v-else-if="amostra.rastro.status_rastro.st_id_externo == 'C'"></i>
                                            {{ amostra.rastro.st_bag_codigo }}
                                        </span>
                                    </span>
                                    <div class="small text-muted">
                                        <span v-if="amostra.rastro.usuario">
                                            {{ amostra.rastro.usuario.st_login }}
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        </span>
                                        {{ $util.getFormatDate(amostra.rastro.created_at) }} {{ amostra.rastro.created_at.substr(11,5) }}                               
                                    </div>
                                </div>
                                <div>
                                    <span class="badge ml-1" 
                                        :class="( exame.atendimento_procedimento.laudo && exame.atendimento_procedimento.laudo.status_laudo && exame.atendimento_procedimento.laudo.status_laudo.st_color ) ? 'badge-' + exame.atendimento_procedimento.laudo.status_laudo.st_color : 'badge-secondary'" 
                                        v-for="(exame, iex) in amostra.exames" :key="iex">
                                        {{ exame.atendimento_procedimento.procedimento.st_sigla ? exame.atendimento_procedimento.procedimento.st_sigla : '#' + exame.atendimento_procedimento.procedimento.id_procedimento }}
                                        <i class="fa-solid fa-circle-exclamation text-danger" v-if="exame.atendimento_procedimento.fl_urgente" title="Urgente"></i>
                                    </span>
                                </div>
                                <div class="mt-2 small">
                                    <div v-if="amostra.js_info && amostra.js_info.volume">
                                        <a href="#" @click.prevent="editar_urina(amostra)" class="card-link">
                                            {{ amostra.js_info.volume }} ml
                                            <i class="fa-solid fa-glass-water fa-fw ml-1"></i>
                                        </a>
                                    </div>
                                    <div v-if="amostra.js_info && amostra.js_info.tempo">
                                        <a href="#" @click.prevent="editar_urina(amostra)" class="card-link">
                                            {{ amostra.js_info.tempo }} h
                                            <i class="fa-solid fa-stopwatch fa-fw ml-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <pre class="mb-5" v-if="false">{{ exibicao }}</pre>
                
            </div>

        </template>
        
        <amostras ref="amostras" />

        <!-- Temperatura do Malote -->
        <div class="modal fade" id="temperaturaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Temperatura do Malote: {{ this.codigo_malote }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            <i class="fa-solid fa-temperature-low fa-fw mr-2"></i>
                            <strong>Informe a temperatura no malote</strong>
                        </div>

                        <az-input
                            id="temperatura"
                            name="temperatura"
                            placeholder="Temperatura..."
                            type="number"
                            required
                            :validate="validate"
                            v-model="temperatura">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">°C</span>
                                </div>
                            </template> 
                        </az-input>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="info_temp()">Informar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Informar Volume/Tempo da Urina -->
        <div class="modal fade" id="urinaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="amostra_urina">
                    <div class="modal-header">
                        <h5 class="modal-title">Urina</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-info" v-if="amostra_urina">
                            <div class="lead">
                                {{ amostra_urina.st_codigo }}
                            </div>
                            <div>
                                #{{ amostra_urina.id_atendimento }}
                            </div>
                            <div>
                                {{ amostra_urina.exame.atendimento_procedimento.atendimento.paciente.st_nome }}
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Volume"
                                    placeholder="Volume..."
                                    type="number"
                                    required
                                    :validate="validate"
                                    v-model="amostra_urina.js_info.volume">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">ml</span>
                                        </div>
                                    </template> 
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Tempo"
                                    placeholder="Tempo..."
                                    type="number"
                                    :max="99"
                                    required
                                    :validate="validate"
                                    v-model="amostra_urina.js_info.tempo">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">h</span>
                                        </div>
                                    </template> 
                                </az-input>
                            </div>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="amostra" :id="amostra_urina.id_amostra" v-if="amostra_urina" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_info_urina()">Informar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <emitir-etiqueta ref="etiqueta" />
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import PrintExport from '../../shared/PrintExport.vue';
import Amostras from './Amostras.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() {
        return { 
            codigo: "", 
            id_amostra_rastro_status: "", 
            paciente: "", 
            lista: [], 
            last_barcode: "", 
            leitura_barcode: false, 
            info: null, 
            tipo_malote: "", 
            uo: null, 
            malote: "", 
            temperatura: null, 
            codigo_malote: "", 
            validate: false, 
            id_amostra_rastro_status_malote: null, 
            amostra_urina: null, 
        }       
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        PrintExport, 
        Amostras,
        AzSubmit, 
        EmitirEtiqueta,
        AzAuditLogButton, 
    },

    watch: { 
        id_amostra_rastro_status: function () { 
            this.codigo = "";
            this.tipo_malote = ""; 
            this.malote = ""; 
            this.lista = [];
        },
    },

    computed: { 
        exibicao: function () { 
            return this.lista;
        },

        dadosFormatados: function () { 
            return [];
        },

        is_monta_bag: function () { 
            return this.info && this.id_amostra_rastro_status_malote && this.id_amostra_rastro_status == this.id_amostra_rastro_status_malote;
        }
    },

    methods: { 
        editar_urina (amostra) { 
            this.amostra_urina = _.cloneDeep(amostra);
            this.validate = false; 
            
            $("#urinaModal").modal("show");
        },

        atualizar_info_urina () { 
            $('#urinaModal').modal('hide');
            this.codigo = this.amostra_urina.st_codigo;
            this.ler(false, this.amostra_urina.js_info);
        },

        tratar_status() { 
            if ( this.id_amostra_rastro_status ) { 
                
                let lista = this.$store.state.options['amostra_rastro_status.index'];

                if ( lista ) { 

                    let status = lista.find(item => item.id_amostra_rastro_status == this.id_amostra_rastro_status);

                    if ( status && status.st_id_externo == 'M' ) { 
                        this.buscar_malotes(this.id_amostra_rastro_status_malote ? true : false);
                    }

                }

            }

        },

        reabrir_malote (malote) { 

            if ( !confirm('Confirma reabrir o malote?') ) { 
                return;
            }

            this.$util.load(this, { 
                service: 'amostras', 
                func: 'rastreabilidade', 
                parms: { 
                    codigo: malote.codigo,
                    id_amostra_rastro_status: this.id_amostra_rastro_status, 
                },
                loadTo: res => { 
                    this.buscar_malotes(true);

                    if ( res.msg ) { 
                        this.$toast.add({
                            severity: "info",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 5000
                        });
                    }
                }
            });

        },

        remover_do_malote (codigo) { 
            if ( !confirm("Confirma remover a amostra '" + codigo + "' do malote?") ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'retirar_do_malote',
                dados: { 
                    codigo: codigo,
                    malote: this.malote.codigo,
                },
                callback: () => { 
                    this.selecionar_malote(this.malote);
                }
            });
        },

        imprimir_etiqueta_malote_2 (codigo, malote) { 
            
            this.$util.atualizar(this, {
                service: "amostras",
                func: "imprimir_etiqueta_malote",
                dados: {
                    codigo: codigo,
                    gerar_malote: true,
                    tipo: ( malote && malote.bag_tipo ) ? malote.bag_tipo.nome : '', 
                },
                callback: res => {
                    this.$refs.etiqueta.emitir('bagAmostra', res.bag, 'id_bag_amostra');
                }
            });
        
        },

        imprimir_etiqueta_malote(codigo) {

            this.$util.atualizar(this, {
                service: "amostras",
                func: "imprimir_etiqueta_malote",
                dados: {
                    codigo: codigo,
                },
                callback: res => {
                    if (res.status == "OK") {
                        let pdfWindow = window.open("");
                        pdfWindow.document.write(
                            "<html><head><title>Etiqueta de Amostra</title></head><body><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                                encodeURI(res.resposta) +
                                "'></iframe></body></html>"
                        );
                    } else {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atualizar",
                            detail: res.mensagem,
                            life: 3000
                        });
                    }
                }
            });

        },

        limpar_lista () { 
            if ( !confirm('Confirma limpar a lista de amostras?') ) { 
                return;
            }

            this.lista = [];
        },

        selecionar_malote (malote) { 
            this.$util.load(this, { 
                service: 'amostras',
                func: 'obter_malote',
                parms: { 
                    codigo: malote.codigo,
                    disponivel: true, 
                },
                loadTo: res => { 
                    this.malote = { 
                        ...res.bag,
                        amostras: res.amostras
                    };

                    if ( this.tipo_malote && this.tipo_malote.bags ) { 
                        let indice = this.tipo_malote.bags.findIndex(item => item.codigo == this.malote.codigo);

                        if ( indice > 0 || indice === 0 ) { 
                            this.tipo_malote.bags[indice] = this.malote;
                        }
                    }


                }
            });
        },

        remover_malote (malote) { 
            if ( !confirm('Confirma remover o malote?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'remover_malote',
                dados: { 
                    codigo: malote.codigo,
                },
                callback: res => { 
                    console.log(res);

                    this.info = null;
                    this.tipo_malote = null;

                    this.$nextTick(() => { 
                        this.buscar_malotes(true);
                    });
                }
            });
        },

        criar_malote () { 
            this.$util.atualizar(this, { 
                service: 'amostras',
                func: 'bagtipos',
                dados: { 
                    uo: this.uo ? _.pick(this.uo, 'id_unidade_operacao', 'st_sigla') : null, 
                    bag_tipo_id: this.tipo_malote.id, 
                    novo: true, 
                },
                callback: res => { 
                    if ( res.bags && res.bags.lista ) { 

                        let tipo_malote = res.bags.lista.find(item => item.id == this.tipo_malote.id);

                        this.info.bags.lista = res.bags.lista;
                        this.tipo_malote = tipo_malote;

                    }
                }
            });
        },

        editar (item) { 
            this.$refs.amostras.abrir(item.id_atendimento, false, item.st_codigo);
        },
        
        abrir_atendimento (item) { 
            this.$util.abrir_atendimento(this, item.id_atendimento);    
        },

        onScan (data) { 

            if ( data.text == this.last_barcode ) { 
                return; 
            }

            this.codigo = data.text;
            this.last_barcode = data.text;

            this.ler()

            setTimeout(() => { 
                this.last_barcode = "";
            }, 2500);

            this.beep();
        },

        beep () { 
            const el = document.getElementById("beepElementId");
            el.play();
        },

        info_temp () { 
            this.codigo = this.codigo_malote; 
            this.ler();
        },

        ler (paciente = false, info_urina = null) { 

            if ( paciente )
                this.lista = [];

            if ( !this.codigo && !this.paciente ) { 
                return;
            }

            let dados = { 
                id_amostra_rastro_status: this.id_amostra_rastro_status, 
            };

            this.$util.setCookie('lab-idr', this.id_amostra_rastro_status);

            if ( this.codigo ) { 
                dados.codigo = this.codigo;
            }

            if ( this.paciente ) { 
                dados.id_pessoa = this.paciente.id_pessoa;
            }

            if ( this.malote ) { 
                dados.malote = this.malote;
            }

            if ( this.temperatura && ( this.temperatura != 'N' ) ) { 
                dados.temperatura = this.temperatura;
                this.temperatura = null;
            }

            if ( info_urina ) { 
                dados.info_urina = info_urina;
            }

            if ( this.codigo && this.codigo.length == 10 && this.id_amostra_rastro_status && this.codigo.slice(0,1) == '5' && !dados.temperatura && dados.temperatura !== 0 && ( this.temperatura != 'N' ) ) { 

                // Consulta do Malote 

                dados.id_amostra_rastro_status = null;
                this.codigo_malote = this.codigo;

                this.$util.load(this, { 
                    service: 'amostras', 
                    func: 'rastreabilidade', 
                    parms: dados,
                    loadTo: res => { 
                        let codigo = this.codigo;

                        this.codigo = "";

                        if ( !res.lista.length ) { 
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: 'Malote não localizado ou sem amostras: ' + codigo,
                                life: 3000
                            });
                        } else { 

                            if ( res.info_temp_saida ) { 
                                this.validate = false;
                                $("#temperaturaModal").modal("show");
                            } else { 
                                this.temperatura = 'N';
                                this.info_temp();
                            }
                        }

                        if ( res.msg ) { 
                            this.$toast.add({
                                severity: "info",
                                summary: "Atenção",
                                detail: res.msg,
                                life: 5000
                            });
                        }
                    }
                });

                return;

            }

            this.$util.load(this, { 
                service: 'amostras', 
                func: 'rastreabilidade', 
                parms: dados,
                modal: 'temperaturaModal',
                loadTo: res => { 

                    let codigo = this.codigo;

                    this.codigo = "";

                    if ( res.refresh_malote && this.malote && this.malote.codigo ) { 

                        if ( res.amostras && res.amostras.length ) { 
                            res.amostras.forEach(item => { 
                                this.malote.rastros.unshift({ 
                                    amostra: item,
                                    amostra_id: item.id,
                                    bag_id: this.malote.id,
                                    id: null,
                                });

                                let amoidx = this.malote.amostras.findIndex(amostra => amostra.codigo == item.codigo);

                                if ( amoidx > 0 || amoidx === 0 ) { 
                                    this.malote.amostras.splice(amoidx, 1);
                                }
                            });
                        } else {                        
                            this.selecionar_malote(this.malote);
                        }

                    } else { 

                        if ( !res.lista.length ) { 
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: 'Amostra não localizada: ' + codigo,
                                life: 3000
                            });
                        } else { 

                            if ( res.lista && res.lista.length == 1 ) { 
                                if ( res.lista[0].fl_info_urina ) { 

                                    if ( !res.lista[0].js_info ) { 
                                        res.lista[0].js_info = {
                                            volume: "",
                                            tempo: "",
                                        };
                                    }

                                    if ( !res.lista[0].js_info.volume ) { 
                                        this.amostra_urina = res.lista[0];
                                        $("#urinaModal").modal("show");
                                        return;
                                    }
                                }
                            }   

                            res.lista.forEach(item => { 
                                this.lista.unshift(item);

                                if ( this.malote ) { 
                                    this.malote.rastros.unshift({ 
                                        ...item, 
                                        leitura: true, 
                                        amostra: { 
                                            codigo: item.st_codigo, 
                                        }
                                    });
                                    
                                    let amoidx = this.info.bags.amostras.findIndex(amostra => amostra.codigo == item.st_codigo);

                                    if ( amoidx > 0 || amoidx === 0 ) { 
                                        this.info.bags.amostras.splice(amoidx, 1);
                                    }
                                }
                            });
                        }

                    }

                    if ( res.msg ) { 
                        
                        this.$toast.add({
                            severity: "info",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 5000
                        });

                    } else { 

                        $('#temperaturaModal').modal('hide');

                    }

                }
                
            });
        },

        load() { 
            //
        },

        buscar_malotes (refresh = false) { 
            this.uo = this.$util.unidade_operacao();

            this.$util.loadItem(this, { 
                service: 'amostras',
                func: 'bagtipos',
                parms: { 
                    uo: this.uo ? this.uo.id_unidade_operacao : null, 
                    novo: false, 
                }
            })
            .then(res => { 
                this.info = res;

                if ( !refresh ) { 
                    let status = _.values(res.status).find(item => item.st_id_externo == 'M');
                    this.id_amostra_rastro_status_malote = _.get(status, 'id_amostra_rastro_status');
                } else { 
                    if ( this.tipo_malote ) { 
                        this.tipo_malote = this.info.bags.lista.find(item => item.id == this.tipo_malote.id);
                    }
                }
            });
        }
    },

    mounted() { 
        let id_def = this.$util.getCookie('lab-idr');

        if ( id_def ) { 
            this.id_amostra_rastro_status = id_def;
        }

        this.$store.commit("setBreadcrumb", [
            { name: 'Laboratório', path: "/laboratorio/visao" },
            { name: "Rastreabilidade de Amostra", path: "/laboratorio/rastreabilidade-amostra" }
        ]);

        // this.buscar_malotes();
    }
}
</script>
